import React from 'react';
import Helmet from 'react-helmet';

import AboutCarousel from '../../components/AboutCarousel';
import SNSPanel from '../../components/SNSPanel';
import Link from '../../components/Link';

import { nl2br } from '../../utils/wordingSystem';

import './index.scss';


const MemberCard = ({ title, job, dialog, image }) => {
  return (
    <div className="about-member-card">
      <div className="dialog">
        <p className="type-heading -ch -md">{dialog}</p>
      </div>
      <div className="box">
        <div className="image"><img src={image} alt="" /></div>
        <div className="info">
          <div className="name type-heading -en -h2">{title}</div>
          <div className="job type-heading -en -h5">{job}</div>
        </div>
      </div>
    </div>
  )
}


const FlowItem = ({ step, title, content, image }) => {
  return (
    <div className="about-workflow-item">
      <div className="step type-heading -en -h4">{step}</div>
      <div className="image"><img src={image} /></div>
      <div className="info">
        <div className="title type-heading -ch -h3">{title}</div>
        <div className="content type-text -ch -md">{content}</div>
      </div>
    </div>
  )
}


const AboutPage = ({ wording }) => {
  const _w = wording;
  return (
    <React.Fragment>
      <Helmet>
        <title>{_w.meta_title}</title>
      </Helmet>
      <SNSPanel />
      <div className="about-page">
        <div className="about-topic">
          <div className="container">
            <div className="topic inner-container">
              <div className="title">
                <h1 className="type-heading -en -h1">
                  <span>{_w.heading}&nbsp;</span>
                  <span className="highlight">{_w.heading_color}</span>
                </h1>
                <p className="type-heading -en -h5">{_w.subheading}</p>
              </div>
              <div className="illustration">
                <img src="/images/about-heading.svg" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div className="about-section-1">
          <div className="container">
            <AboutCarousel className="slider" data={[
              { title: _w.section1.space.title, label: _w.section1.space.label, content: _w.section1.space.content, illustration: '/images/about-section-space.svg' },
              { title: _w.section1.branding.title, label: _w.section1.branding.label, content: _w.section1.branding.content, illustration: '/images/about-section-branding.svg' },
              { title: _w.section1.human.title, label: _w.section1.human.label, content: _w.section1.human.content, illustration: '/images/about-section-human.svg' },
              { title: _w.section1.human.title, label: _w.section1.human.label, content: _w.section1.human.content, dots: _w.section1.final.highlight, hide: nl2br(_w.section1.final.normal), illustration: '/images/about-section-human.svg' },
              { title: _w.section1.human.title, label: _w.section1.human.label, content: _w.section1.human.content, dots: _w.section1.final.highlight, heading: nl2br(_w.section1.final.normal), illustration: '/images/about-section-human.svg' }
            ]}>
            </AboutCarousel>
          </div>
        </div>
        {/* <div className="about-section-2">
          <div className="container">
            <div className="heading type-heading -en -h2">{nl2br(_w.section2.title)}</div>
            <div className="member-list">
              <div className="item">
                <MemberCard
                  image="/images/about-member-stan.svg"
                  title={_w.section2.stan.name}
                  job={_w.section2.stan.job}
                  dialog={_w.section2.stan.dialog} />
              </div>
              <div className="item">
                <MemberCard
                  image="/images/about-member-shelby.svg"
                  title={_w.section2.shelby.name}
                  job={_w.section2.shelby.job}
                  dialog={_w.section2.shelby.dialog} />
              </div>
              <div className="item">
                <MemberCard
                  image="/images/about-member-yao.svg"
                  title={_w.section2.yao.name}
                  job={_w.section2.yao.job}
                  dialog={_w.section2.yao.dialog} />
              </div>
              <div className="item">
                <MemberCard
                  image="/images/about-member-ollix.svg"
                  title={_w.section2.ollix.name}
                  job={_w.section2.ollix.job}
                  dialog={_w.section2.ollix.dialog} />
              </div>
              <div className="item">
                <MemberCard
                  image="/images/about-member-miu.svg"
                  title={_w.section2.miu.name}
                  job={_w.section2.miu.job}
                  dialog={_w.section2.miu.dialog} />
              </div>
              <div className="item">
                <MemberCard
                  image="/images/about-member-ninn.svg"
                  title={_w.section2.ninn.name}
                  job={_w.section2.ninn.job}
                  dialog={_w.section2.ninn.dialog} />
              </div>
              <div className="item">
                <MemberCard
                  image="/images/about-member-joanne.svg"
                  title={_w.section2.joanne.name}
                  job={_w.section2.joanne.job}
                  dialog={_w.section2.joanne.dialog} />
              </div>
            </div>
          </div>
        </div> */}
        <div className="about-section-3">
          <div className="container">
            <div className="heading type-heading -en -h2">{nl2br(_w.section3.title)}</div>
            <div className="workflow">
              {
                _w.section3.steps.map((step, id) => (
                  <FlowItem key={id} step={step.step_label} image={step.img} title={step.title} content={nl2br(step.content)} />
                ))
              }
            </div>
          </div>
        </div>
        <div className="about-section-4">
          <div className="container">
            <div className="heading type-heading -en -h2">{nl2br(_w.section4.title)}</div>
            <div className="contact">
              <div className="info">
                <p className="type-heading -ch -h3">{_w.section4.content}</p>
                <Link className="info-contact text-button -dark" to="/contact">CONTACT US</Link>
              </div>
              <div className="illustration">
                <img src="/images/about-contact.svg" alt="" />
              </div>
              <div className="bottom-contact">
                <Link className="text-button -dark" to="/contact">CONTACT US</Link>
              </div>
            </div>
          </div>
        </div>

        <div className="about-section-5">
          <div className="container">
            <div className="heading type-heading -en -h2">Our Awards</div>

            <div className="award-list">
              <h3>2024</h3>
              <ul>
                <li>London Design Awards- Gold Winner</li>
              </ul>
              <h3>2023</h3>
              <ul>
                <li>IDA International Design Awards- Honorable Mention</li>
                <li>MUSE Design Awards- Golden</li>
                <li>A' Design Award- Silver</li>
                <li>Arch Design Awards- Silver</li>
              </ul>

              <h3>2020</h3>
              <ul>
                <li>
                  The 10th International Space Design Award Idea-Tops (Shenzhen division)<br />
                  <q>Shortlisted Candidate for The Best Office space Design</q><br />
                  <q>Shortlisted Candidate for The Best Apartment Design </q>
                </li>
              </ul>

              <h3>2016</h3>
              <ul>
                <li>
                  住宅案榮獲第六屆亞洲設計獎<br />
                  <q>鄉村休閒組《優良設計獎》</q><br />
                  <q>軟裝佈置組《傑出設計獎》</q>
                </li>
                <li>住宅案入圍第六屆亞洲設計獎-多元混搭組</li>
              </ul>

              <h3>2015</h3>
              <ul>
                <li>Gorgeous Space Asia Design Award</li>
              </ul>
            </div>
          </div>
        </div>

      </div>
    </React.Fragment>
  )
}

export default AboutPage;
